// © Microsoft Corporation. All rights reserved.

import { ChildExperienceConfigInfo } from "./ChildExperienceConfigInfo";

/**
 * Specifies validator for child experience
 * @export
 * @interface
 */
export interface ChildExperienceValidator {
    /**
     * section name from where child element should be removed
     */
    sectionName: ValidatorSectionName;

    /**
     * ChildExperienceConfigInfo object to be removed
     */
    childExperienceConfigInfo: ChildExperienceConfigInfo;

    /**
     * Optional validation arguments
     */
    validationArgs?: ValidationArgs;
}

/**
 * section name from where child element should be removed. We can add more support in this list as additionalChildExperiences
 * or childExperienceMap. The current design and approach support that.
 */
export enum ValidatorSectionName {
    /**
     * Section name for River Grid children, positioned by row/column syntax
     */
    riverGridChildren = "riverGridChildren"
}

/**
 * Validation arguments to determine experience enable / disable
 * @export
 * @interface
 */
export interface ValidationArgs {
}